import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["studentProgramStatusPanel"]

  connect() {
    this.toggleStudentProgramPanel()
  }

  updateInstructorSelection(event) {
    // The instructor selector widget automatically updates the hidden field
    this.toggleStudentProgramPanel(event.detail?.id)
  }

  toggleStudentProgramPanel(recipientId = null) {
    if (!this.hasStudentProgramStatusPanelTarget) return
    const id = recipientId ?? document.getElementById("driveato_messaging_recipient_selector")?.value ?? ""
    const isStudentProgram = String(id).startsWith("student_program_")
    this.studentProgramStatusPanelTarget.classList.toggle("u-hidden", !isStudentProgram)
  }
}

